<template>
  <div>
    <div
      v-for="entry in balanceEntries"
      :key="entry.totalPointsAmount"
      class="flex flex-col lg:flex-row lg:items-end px-4 py-4"
    >
      <div class="lg:pr-6 text-xs">°Punktestand:</div>
      <div class="text-[70px] leading-[70px] font-extrabold">
        {{ Number(entry.totalPointsAmount ?? 0).toLocaleString('de-DE') }}&nbsp;<span class="text-3xl lg:hidden"
          >°P</span
        >
      </div>
      <div class="hidden lg:block pl-2 text-2xl">°Punkte</div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface PaybackAccountBalanceEntry {
  totalPointsAmount: number
  availablePointsAmount: number
  blockedPointsAmount: number
}

interface PaybackAccountBalanceResponse {
  accountBalanceDetails: PaybackAccountBalanceEntry[]
}

const { data: balance, error: balanceError } = await useFetch<PaybackAccountBalanceResponse>('/api/payback/members/account-balance/', { retryStatusCodes() { return [401, 408, 409, 425, 429, 500, 502, 503, 504] } });

if (balanceError) {
  throw createError({ data: { code: balanceError.value?.data?.code } });
}

const balanceEntries = computed(() => balance.value?.accountBalanceDetails ?? [])
</script>

<style scoped lang="postcss"></style>
